import React, { FC } from 'react'
import classNames from 'classnames'
import text from 'styles/utility/text.module.scss'
import { Card, CardInner, ReceiveCardListDetail } from 'components/Card'
import { Spacer } from 'components/Utility'
import { SubDescription } from 'components/Typography'
import { mailMenus } from 'constants/menus'
import { StaffType } from 'types/staff'
import { useHandleReceiveSetting } from 'hooks/auth'
import { useQueryStoreName } from 'hooks/store'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getStoreRef } from 'reducks/auth/selectors'

type Props = {
  staff?: StaffType
}

const ReceiveCard: FC<Props> = (props) => {
  const { staff } = props
  const storeRef = useSelector((state: State) => getStoreRef(state))
  const storeName = useQueryStoreName(storeRef)
  const { mails, uid } = useHandleReceiveSetting(staff)
  return (
    <Card>
      <CardInner>
        <Spacer size={4} />
        <h3 className={classNames(text.font_xxlarge, text.align_center, text.font_bold)}>メール受信設定</h3>
        <Spacer size={20} />
        <p className={classNames(text.font_small, text.align_center, text.color_grey_01)}>
          設定する店舗：
          <span className={classNames(text.font_default, text.font_bold)}>{storeName}</span>
        </p>
        <Spacer size={12} />
        <SubDescription description={'別の店舗の設定を行う場合は、店舗を切り替えてから設定してください。'} />
        <Spacer size={20} />
        {mailMenus.map((menu) => {
          const mail = mails.find((_mail) => _mail.store_ref.id === storeRef.id)
          if (!mail) return
          return (
            <ReceiveCardListDetail
              key={menu.permission}
              label={menu.label}
              mail={mail}
              mails={mails}
              permission={menu.permission}
              staff={staff}
              uid={uid}
            />
          )
        })}
      </CardInner>
    </Card>
  )
}

export default ReceiveCard
